<div class="gc-chat-box bc-panel" [class.focused]="isFocused">
  <ng-container *ngIf="!isTransferPanelOpen">
    <div class="gc-chat-header bc-panel-header">
      <div class="bc-panel-header-text">
        <svg-icon icon="genesys-{{ conversationType }}" class="bc-panel-header-icon"></svg-icon>
        <span class="chat-title-text gc-text-bold">{{ 'gcChatBox.headerTitle.' + conversationType | translate }}</span>
      </div>
    </div>

    <app-genesys-chat-box-scrollable-body
      class="panel-body"
      [contact]="contact"
      [conversationId]="conversationId"
      [isMessagingPeriodEnded]="isMessagingPeriodEnded"
    ></app-genesys-chat-box-scrollable-body>
    <app-genesys-chat-toast-messages [conversationId]="conversationId"></app-genesys-chat-toast-messages>

    <app-genesys-chat-footer
      [isExpandedMode]="isExpandedMode"
      [conversationId]="conversationId"
      [isFocused]="isFocused"
      [isConversationOpen]="isConversationOpen"
      [isConversationAcceptable]="isConversationAcceptable"
      [isWrapUpRequired]="isWrapUpRequired"
      [conversationType]="conversationType"
      [isMessagingPeriodEnded]="isMessagingPeriodEnded"
      [isCobrowseActive]="isCobrowseActive"
      (editorContentChange)="onEditorContentChange($event)"
      (openTransferPanel)="onTransferPanelOpen()"
    ></app-genesys-chat-footer>
  </ng-container>

  <app-genesys-transfer-panel
    *ngIf="isTransferPanelOpen"
    class="gc-chat-box-transfer-panel"
    [conversationId]="conversationId"
    [agentParticipantId]="agentParticipantId"
    [communicationType]="communicationTypes.Message"
    (cancel)="onTransferPanelCancel()"
  >
  </app-genesys-transfer-panel>
</div>
<div *ngIf="!isFocused" class="gc-chat-box-inactive-footer" [attr.data-automation-id]="'gc-chat-box-inactive-footer'">
  <app-inactive-widget-footer [text]="editorContentChange"></app-inactive-widget-footer>
</div>
